import {USERS_DASHBOARD} from "../../constants/routes";

const getUserTopPageSettings = () => {
    localStorage.setItem('backUrl', USERS_DASHBOARD);
    return {
        success: true,
        message: "Get page settings successfully.",
        data: {
            menu_items: [
                { name: "user-master-update" },
                { name: "user-master-history-search" },
                { name: "user-master-import" },
                { name: "user-master-export" },
                { name: "user-master-search" },
            ],
            sidebar: {}
        }
    }
};

const getUserHistorySearchLogSettings = () => {
    localStorage.setItem('backUrl', USERS_DASHBOARD);
    return {
        success: true,
        message: "Get page settings successfully.",
        data: {
            sidebar: {
                "title": "",
                "items": [
                    { name: "user-master-update"},
                    { name: "user-master-history-search", active: true },
                    { name: "user-master-import"},
                    { name: "user-master-export" },
                    { name: "user-master-search" },
                ],
            }
        }
    }
};

const getUserImportPageSettings = () => {
    localStorage.setItem('backUrl', USERS_DASHBOARD);
    return {
        success: true,
        message: "Get page settings successfully.",
        data: {
            sidebar: {
                "title": "",
                "items": [
                    { name: "user-master-update"},
                    { name: "user-master-history-search" },
                    { name: "user-master-import", active: true},
                    { name: "user-master-export" },
                    { name: "user-master-search" },
                ],
            }
        }
    }
};

const getUserExportPageSettings = () => {
    localStorage.setItem('backUrl', USERS_DASHBOARD);
    return {
        success: true,
        message: "Get page settings successfully.",
        data: {
            sidebar: {
                "title": "",
                "items": [
                    { name: "user-master-update"},
                    { name: "user-master-history-search" },
                    { name: "user-master-import"},
                    { name: "user-master-export", active: true},
                    { name: "user-master-search" },
                ],
            }
        }
    }
};

const getUserUpdatePageSettings = () => {
    localStorage.setItem('backUrl', USERS_DASHBOARD);
    return {
        success: true,
        message: "Get page settings successfully.",
        data: {
            sidebar: {
                "title": "",
                "items": [
                    { name: "user-master-update", active: true },
                    { name: "user-master-history-search" },
                    { name: "user-master-import" },
                    { name: "user-master-export" },
                    { name: "user-master-search" },
                ],
            }
        }
    }

};

const getUserSearchPageSettings = () => {
    localStorage.setItem('backUrl', USERS_DASHBOARD);
    return {
    success: true,
    message: "Get page settings successfully.",
    data: {
      sidebar: {
        "title": "",
        "items": [
          { name: "user-master-update"},
          { name: "user-master-history-search" },
          { name: "user-master-import" },
          { name: "user-master-export" },
          { name: "user-master-search", active: true },
        ],
      }
    }
  }
};

export {
    getUserTopPageSettings,
    getUserHistorySearchLogSettings,
    getUserImportPageSettings,
    getUserUpdatePageSettings,
    getUserExportPageSettings,
    getUserSearchPageSettings
}